import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { ExternalUrlCheckerProps } from './types';

function ExternalUrlChecker({ children, isFirstLoad, setIsFirstLoad }: ExternalUrlCheckerProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isFirstLoad) return;
    setIsFirstLoad(false);
    navigate('/', { replace: true });
  }, [isFirstLoad, navigate, setIsFirstLoad]);

  return children;
}

export default ExternalUrlChecker;
